var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4536",
    "data-name": "Rectangle 4536",
    width: 20,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-2.498 -2.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16004",
    "data-name": "Path 16004",
    d: "M21.7,3.3a2.72,2.72,0,0,0-3.855,0L8.06,13.109a.5.5,0,0,0-.14.295L7.5,16.939a.5.5,0,0,0,.5.56h.055l3.565-.37a.5.5,0,0,0,.3-.145L21.7,7.17a2.745,2.745,0,0,0,0-3.87ZM11.34,16.144l-2.77.295.32-2.745,7.73-7.75,2.445,2.45Zm8.43-8.455L17.324,5.235,18.549,4A1.765,1.765,0,0,1,21,4a1.735,1.735,0,0,1,0,2.45Z",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16005",
    "data-name": "Path 16005",
    d: "M19.5,19A2.5,2.5,0,0,1,17,21.5H6A2.5,2.5,0,0,1,3.5,19V8A2.5,2.5,0,0,1,6,5.5h7.5v-1H6A3.5,3.5,0,0,0,2.5,8V19A3.5,3.5,0,0,0,6,22.5H17A3.5,3.5,0,0,0,20.5,19V11.5h-1Z",
    fill: "#5d5d5d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d5f8c596ce6ef9a36288ec911d6a3039.svg";
export { ForwardRef as ReactComponent };